import React, {useEffect, useRef, useState} from "react";
import VkUserProjectData from "../../../Interfaces/VkUserProjectData";
import Isotope from "isotope-layout";
import {ErrorBoundary} from "../../Common/ErrorBoundary";
import MyVideoListItem from "./MyVideoListItem";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {useMutation} from "@tanstack/react-query";
import axios from "axios";
import * as Sentry from "@sentry/react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {SWAL_ALERT_DEFAULTS} from "../../../Utils/defaults";
import getVkUserProjectsData from "../../../Api/getVkUserProjectsData";

interface MyVideoListProps {
    vkUserProjects: VkUserProjectData[],
    currentTab: string,
}

const MyVideoList: React.FC<MyVideoListProps> = ({vkUserProjects, currentTab}) => {

    const [isotope, setIsotope] = useState<Isotope>();
    const isotopeRef = useRef<HTMLDivElement>(null);

    const dispatch = useAppDispatch();
    const makerData = useAppSelector(state => state.makerData)

    const mutation = useMutation({
        mutationFn: getVkUserProjectsData,
        onError: (error, variables, context) => {
            let errorUrl = '';
            if (axios.isAxiosError(error)) {
                errorUrl = String(error.config?.url);
                // @ts-ignore
            } else if (typeof error?.url !== 'undefined') {
                // @ts-ignore
                errorUrl = error?.url;
            }
            Sentry.captureException(
                // @ts-ignore
                new Error((error?.message ? error.message : 'Failed to load vk user projects. Generic error.') + ', URL: ' + errorUrl),
                {
                    extra: {
                        variables: variables,
                        error: error,
                        responseConfig: axios.isAxiosError(error) ? JSON.stringify(error.response?.config) : '',
                        responseData: axios.isAxiosError(error) ? JSON.stringify(error.response?.data) : ''
                    }
                }
            )
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                ...SWAL_ALERT_DEFAULTS,
                title: 'Ошибка',
                text: 'Ошибка загрузки данных. Попробуйте обновить страницу.',
                icon: 'error'
            });
        },
        retry: 5,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000)
    })

    const onImageLoaded = (data: VkUserProjectData) => {
        if (isotope) {
            isotope.layout();
        }
    }

    useEffect(() => {
        if (currentTab == 'my-video') {
            mutation.mutateAsync({
                params: {},
                dispatch: dispatch,
                makerData: makerData
            }).catch(e => {});
        }
    }, [currentTab])

    useEffect(() => {
        if (isotope) {
            isotope.layout();
        }
    }, [currentTab])

    useEffect(() => {
        if (!isotope) {
            if (isotopeRef.current) {
                const isotope2 = new Isotope(isotopeRef.current, {
                    itemSelector: '.grid-item',
                    layoutMode: 'masonry',
                    transitionDuration: '0.45s',
                    resize: true,
                    filter: '*',
                    stagger: 0,
                    percentPosition: true,
                    masonry: {
                        columnWidth: '.grid-sizer'
                    }
                })
                setIsotope(isotope2)
            }
        } else {
            isotope.reloadItems();
            isotope.layout();
        }
    }, [vkUserProjects]);

    return (
        <div className="my-video-container">
            <div className="my-video-grid">
                {
                    vkUserProjects.map(
                        (project, index) =>
                            <ErrorBoundary
                                place={'MyVideo-MyVideoItem'}
                                key={project.vp + '-my-video-error-boundary'}>
                                <MyVideoListItem
                                    data={project}
                                    index={index}
                                    onImageLoaded={onImageLoaded}
                                />
                            </ErrorBoundary>
                    )
                }
            </div>
        </div>
    )
}

export default MyVideoList;